import React from 'react';
import styled from 'styled-components';
import { RawDraftContentState } from 'react-draft-wysiwyg';
import { useTranslate } from '@bynder/localization';
import { MAX_LENGTH_TITLE_WIDGET } from '../../constants/widgets';
import RichText from './RichText';
import { getTypography } from '../shared/styled-components/constants';
import { TEXT } from '../../constants/styles';
import { TypographyHeading } from '../../types/typography';

interface Props {
  widgetId: string;
  columnIndex: number;
  sectionId: string;
  content?: RawDraftContentState;
  readOnly?: boolean;
}

const TitleWidget: React.FC<Props> = ({
  widgetId,
  columnIndex,
  sectionId,
  content,
  readOnly,
}) => {
  const { translate } = useTranslate();

  return (
    <StyledTitleWidget>
      <RichText
        columnIndex={columnIndex}
        widgetId={widgetId}
        sectionId={sectionId}
        content={content}
        maxLength={MAX_LENGTH_TITLE_WIDGET}
        placeholder={translate('TITLE_WIDGET.PLACEHOLDER')}
        readOnly={readOnly}
        autofocus={!content}
        inlineContent
      />
    </StyledTitleWidget>
  );
};

export default TitleWidget;

export const StyledTitleWidget = styled.div`
  && .DraftEditor-root {
    ${props => getTypography(TypographyHeading.H2, props.theme, false)};
    font-size: ${TEXT.FONT_SIZE_TITLE};
  }
`;
